import { createContext, FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';

export type InternationalizationFn = (
  i18nString: string | string[],
  ns?: { ns: string },
) => string;
type II18nContext = [InternationalizationFn, any];

const i18nContext = createContext<II18nContext>([(val) => val as any, 'en']);

const Provider = i18nContext.Provider;
i18nContext.displayName = 'I18nProvider';

export const I18nProvider: FC<{ children: any }> = ({ children }) => {
  const { t, i18n } = useTranslation(['inverse', 'inverse-error-code']);
  const lang = i18n.language || 'en';
  let _t = t;
  if (t('accountBaseInfo') === 'accountBaseInfo') {
    _t = function (key: string | string[]) {
      if (Array.isArray(key)) {
        return key;
      }
      const keySplit = key.split('.');
      if (keySplit.length) {
        const str = keySplit.reduce(
          (obj, curKey: string) => obj?.[curKey] || curKey,
          window.appDefaultLang,
        );
        return str;
      }
      return window.appDefaultLang?.[key] || key;
    };
  }

  return <Provider value={[_t, lang]}>{children}</Provider>;
};

export function useI18nContext() {
  return useContext(i18nContext);
}
